export class setupPasswordApplyInfo {
    constructor(password, repassword) {
        this.password = password;
        this.repassword = repassword;
    }
}